export const styles = {
	popperFont: {
		color: 'black',
		fontSize: '12px',
		zIndex: 10000,
	},
	popperContent: (popperBackgroundColor?: string) => ({
		border: 'none',
		p: 2,
		bgcolor: popperBackgroundColor ?? 'background.hover',
		maxWidth: '350px',
		zIndex: 99999,
		fontSize: '44px',
	}),
	introTextContainer: {
		pt: '10px',
	},
	bulletTitle: {
		fontSize: '12px',
		mt: '10px',
	},
	bulletList: {
		marginTop: 0,
		paddingInlineStart: '20px',
	},
	subBulletList: {
		marginTop: '6px',
		paddingInlineStart: '20px',
	},
	bulletLink: {
		textDecoration: 'underline',
		color: 'inherit',
	},
	closingText: {
		fontSize: '12px',
	},
}
